(() => {
  function initPopularCategoriesProgress(root = document) {
    const sections = [];

    if (root.matches?.('.leobela-popular-categories')) {
      sections.push(root);
    }

    root
      .querySelectorAll?.('.leobela-popular-categories')
      .forEach((section) => sections.push(section));

    sections.forEach((section) => {
      const slider = section.querySelector('[id^="Slider-"]');
      const progressBar = section.querySelector(
        '.leobela-popular-categories__progress-bar'
      );

      if (!slider || !progressBar) return;

      const updateProgress = () => {
        const maximumScroll = Math.max(
          slider.scrollWidth - slider.clientWidth,
          0
        );

        const visibleRatio = Math.min(
          slider.clientWidth / slider.scrollWidth,
          1
        );

        const scrollProgress =
          maximumScroll > 0
            ? Math.min(
                Math.max(slider.scrollLeft / maximumScroll, 0),
                1
              )
            : 0;

        const indicatorWidth = visibleRatio * 100;
        const indicatorPosition =
          scrollProgress * (100 - indicatorWidth);

        progressBar.style.width = `${indicatorWidth}%`;
        progressBar.style.left = `${indicatorPosition}%`;
      };

      if (slider.dataset.leobelaPopularProgressBound !== 'true') {
        let animationFrame;

        slider.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(animationFrame);
            animationFrame = requestAnimationFrame(updateProgress);
          },
          { passive: true }
        );

        window.addEventListener('resize', updateProgress);

        slider.dataset.leobelaPopularProgressBound = 'true';
      }

      updateProgress();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initPopularCategoriesProgress(),
      { once: true }
    );
  } else {
    initPopularCategoriesProgress();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPopularCategoriesProgress(event.target);
  });
})();